import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApiTokenService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import {
  CreateApiTokenCommand,
  GetApiTokenByIdDto,
  UpdateApiTokenIpCommand,
} from '../../../../core/api/models';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";

@Component({
    selector: 'app-api-token-form',
    templateUrl: './api-token-form.component.html',
    imports: [BaseFormModule, ModalTitleComponent]
})

export class ApiTokenFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  fields = 'pages.apiToken.form.fields.';

  formPageConfig: FormPageConfig<GetApiTokenByIdDto> = {};
  model: CreateApiTokenCommand = {};
  id: number;
  ips: string;
  allIps: string[] = [];
  maxWidth: string = '';
  organizationId: number;
  //#endregion

  constructor(
    protected currentService: ApiTokenService,
    private dialogRef: MatDialogRef<ApiTokenFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private brObs: BreakpointObserver,
    private dialogService: DialogService
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
    this.id = data?.model?.id;
    this.ips = data?.model?.ip;
    this.organizationId = data?.organizationId;

    this.brObs
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .subscribe((result) => {
        if (result.breakpoints[Breakpoints.XSmall])
          this.maxWidth = 'tw-w-[400px]';

        if (result.breakpoints[Breakpoints.Small]) {
          this.maxWidth = 'tw-w-[500px]';
        }

        if (result.breakpoints[Breakpoints.Medium]) {
          this.maxWidth = 'tw-w-[600px]';
        }
        if (result.breakpoints[Breakpoints.Large]) {
          this.maxWidth = 'tw-w-[700px]';
        }
        if (result.breakpoints[Breakpoints.XLarge]) {
          this.maxWidth = 'tw-w-[700px]';
        }
      });
  }

  ngOnInit() {
    this.initModel();
    this.initForm();
  }

  //#region init methods
  initModel(): void {
    if (this.formPageConfig.isEditMode && this.ips != '') {
      this.allIps = this.ips.split(',');
      this.model.isCanSend = this.data?.model.isCanSend;
      this.model.isCanSendSmart = this.data?.model.isCanSendSmart;
      this.model.isIgnoreCheckIp = this.data?.model.isIgnoreCheckIp;
      this.model.description = this.data?.model.description;
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      ip: new FormControl(''),
      isCanSend: new FormControl(''),
      isCanSendSmart: new FormControl(''),
      isIgnoreCheckIp: new FormControl(''),
      description: new FormControl(''),
    });
  }

  //#endregion

  //#region api

  //Create
  baseCreateApi(model: CreateApiTokenCommand): void {
    this.unSubs();

    this.loading = true;

    this.currentService
      .apiTokenCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateApiTokenIpCommand): void {
    this.unSubs();

    this.loading = true;

    model.id = this.id;
    this.currentService
      .apiTokenUpdateApiTokenIp({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  getIps(ips: any[]) {
    this.model.ip = ips.toString();
  }

  onSubmit() {
    if (this.loading) return;
    if (!this.model.ip) {
      const msg = 'messages.requiredMsg';
      this.dialogService.openDialog({
        title: 'common.error',
        message: msg,
        status: DialogStatus.error,
      });
      return;
    }
    try {
      this.checkCreateOrUpdate();
    } catch (error) {
      ConsoleService.error('error', error);
      this.loggerService.logError(this.tagName, error, EventTypes.baseFormPage);
    }
  }
}
